import React from 'react';


/* _frfr-universal-components UNICOMPO UNIVERSAL SMALL ELEMENTS/COMPONENTS */
/*
PROPS:
props.extraClass
*/

const UniInlineCode = (props) => {
  let extraClass = '';
  if (typeof props.extraClass === 'string') {
    extraClass = ' ' + props.extraClass;
  }
  return (
    <code className={"unicompo-inline-code" + extraClass}>{props.children}</code>
  );
};

export default UniInlineCode;